export function beforeSave(record) {
  const newRecord = { ...record };
  // get rid of empty lines
  newRecord.outputs = record.outputs.filter(({ item }) => item?.id);
  newRecord.inputs = record.inputs.filter(({ item }) => item?.id);
  return newRecord;
}
